import { CustomFieldClassType } from '@cims-online/shared'
import PayItemSelectProvider from 'components/CIMSSelect/common/PayItemSelect/PayItemSelectContext'
import { WithPayItemGlobalId } from 'components/CIMSTable/components/HeaderActionButtons/types'
import { ProjectCustomFieldsProvider } from 'components/CustomFields/ProjectCustomFieldsContext'
import EJLogTable from './components/EJLogTable'
import { EJLogProvider } from './EJLogContext'
import EJReportsSelectOptionsProvider from '../EJReportsSelectOptionsContext'

const EJLog: React.VFC<WithPayItemGlobalId> = ({ payItemGlobalId }) => (
  <ProjectCustomFieldsProvider
    classType={CustomFieldClassType.EngineeringJudgement}
  >
    <PayItemSelectProvider>
      <EJReportsSelectOptionsProvider>
        <EJLogProvider payItemGlobalId={payItemGlobalId}>
          <EJLogTable />
        </EJLogProvider>
      </EJReportsSelectOptionsProvider>
    </PayItemSelectProvider>
  </ProjectCustomFieldsProvider>
)

export default EJLog
